/**
 * @generated SignedSource<<310107fc464f99e53d5c4ed486e94917>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentAssetTransfer_metadata$data = {
  readonly receivedAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly decimals: number | null | undefined;
      readonly symbol: string | null | undefined;
      readonly usdSpotPrice: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PaymentAssetMedia_asset">;
    };
    readonly quantity: string;
  }>;
  readonly sentAssetQuantities: ReadonlyArray<{
    readonly asset: {
      readonly decimals: number | null | undefined;
      readonly symbol: string | null | undefined;
      readonly usdSpotPrice: number | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"PaymentAssetMedia_asset">;
    };
    readonly quantity: string;
  }>;
  readonly " $fragmentType": "PaymentAssetTransfer_metadata";
};
export type PaymentAssetTransfer_metadata$key = {
  readonly " $data"?: PaymentAssetTransfer_metadata$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentAssetTransfer_metadata">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AssetType",
    "kind": "LinkedField",
    "name": "asset",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "symbol",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "decimals",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usdSpotPrice",
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PaymentAssetMedia_asset"
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantity",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentAssetTransfer_metadata",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "sentAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetQuantityType",
      "kind": "LinkedField",
      "name": "receivedAssetQuantities",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "TransactionMetadataType",
  "abstractKey": null
};
})();

(node as any).hash = "26ca9f805f791b81a14750c098fbc15b";

export default node;
